export default __webpack_public_path__ + "static/media/bg07.c68fe208.svg";